import StringUtils from './StringUtils';

class FileUtils {
    static raiseEvent(name, detail, props) {
        let handlerName = StringUtils.snakeCaseToCamelCase(`on-${name}`);

        if (props[handlerName]) {
            let event = new Event(name);
            event.detail = detail;
    
            props[handlerName](event);
        }
        
    }
}

export default FileUtils;